let audioContext = null

/**
 * Short, soft chime for new online booking alerts.
 */
export function playOnlineBookingNotificationSound() {
  if (typeof window === 'undefined') {
    return
  }

  try {
    const AudioContextClass = window.AudioContext || window.webkitAudioContext
    if (!AudioContextClass) {
      return
    }

    if (!audioContext) {
      audioContext = new AudioContextClass()
    }

    if (audioContext.state === 'suspended') {
      void audioContext.resume()
    }

    const now = audioContext.currentTime
    const gain = audioContext.createGain()
    gain.connect(audioContext.destination)
    gain.gain.setValueAtTime(0.0001, now)
    gain.gain.exponentialRampToValueAtTime(0.08, now + 0.02)
    gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.55)

    const playTone = (frequency, start, duration) => {
      const oscillator = audioContext.createOscillator()
      oscillator.type = 'sine'
      oscillator.frequency.setValueAtTime(frequency, start)
      oscillator.connect(gain)
      oscillator.start(start)
      oscillator.stop(start + duration)
    }

    playTone(880, now, 0.18)
    playTone(1174.66, now + 0.12, 0.22)
  } catch {
    // Browsers may block audio until user interaction — fail silently.
  }
}
